import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchTestimonials(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/testimonials', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchTestimonial(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/testimonial/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateTestimonial(ctx, { id, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/testimonial/${id}/update`, payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        desactivateTestimonial(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/testimonial/${id}/desactivate`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        activateTestimonial(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/testimonial/${id}/activate`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}
